import 'ol/ol.css';
import {Map, View} from 'ol';
import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';
import {fromLonLat, toLonLat} from 'ol/proj';
import Overlay from 'ol/Overlay';
import {toStringHDMS} from 'ol/coordinate';
import { izracunaj, update } from './karta.js';

var layer = new TileLayer({
    source: new OSM(),
  });

const map = new Map({
  target: 'karta',
  layers: [
    new TileLayer({
      source: new OSM()
    })
  ],
  view: new View({
    center: fromLonLat([16.29249556 , 44.72135627]),
    zoom: 7
  })
});

// Popup showing the position the user clicked
var popup = new Overlay({
    element: document.getElementById('popup'),
});
map.addOverlay(popup);

map.on('click', function (evt) {
    var element = popup.getElement();
    var coordinate = evt.coordinate;
    //console.log(coordinate);
    var lonLat = toLonLat(coordinate);
    //console.log(lonLat);
    var hdms = toStringHDMS(lonLat);
   // console.log(hdms);

    izracunaj(lonLat[0],lonLat[1]);

	document.getElementById("x_stupanj1").value=lonLat[0]
	document.getElementById("y_stupanj1").value=lonLat[1];
	update("x",1,true);
  update("y",1,true);
    
    $(element).popover('dispose');
    popup.setPosition(coordinate);
    $(element).popover({
      container: element,
      placement: 'top',
      animation: false,
      html: true,
      content: 'Traži...',
    });
    $(element).popover('show');
});

function prikazi() 
{
  var lon = document.getElementById("x_stupanj1").value;
  var lat = document.getElementById("y_stupanj1").value;

  var inputNotEmpty = lon != "" && lat != "";

  if (inputNotEmpty) {
    izracunaj(document.getElementById("x_stupanj1").value, document.getElementById("y_stupanj1").value);

    var element = document.getElementById("popup");
    var coordinate = fromLonLat([lon, lat]);
    
    $(element).popover('dispose');
    popup.setPosition(coordinate);
    $(element).popover({
      container: element,
      placement: 'top',
      animation: false,
      html: true,
      content: 'Traži...',
    });
    $(element).popover('show');
  }
}

document.getElementById("prikaziButton").addEventListener("click", prikazi, false);

document.getElementById("x_stupanj1").addEventListener("change", updateX1, false);

document.getElementById("x_stupanj2").addEventListener("change", updateX2, false);
document.getElementById("x_minuta2").addEventListener("change", updateX2, false);

document.getElementById("x_stupanj3").addEventListener("change", updateX3, false);
document.getElementById("x_minuta3").addEventListener("change", updateX3, false);
document.getElementById("x_sekunda3").addEventListener("change", updateX3, false);

document.getElementById("y_stupanj1").addEventListener("change", updateY1, false);

document.getElementById("y_stupanj2").addEventListener("change", updateY2, false);
document.getElementById("y_minuta2").addEventListener("change", updateY2, false);

document.getElementById("y_stupanj3").addEventListener("change", updateY3, false);
document.getElementById("y_minuta3").addEventListener("change", updateY3, false);
document.getElementById("y_sekunda3").addEventListener("change", updateY3, false); 

function updateX1() 
{
  update('x',1,false);
}

function updateX2() 
{
  update('x',2,false);
}

function updateX3() 
{
  update('x',3,false);
}

function updateY1() 
{
  update('y',1,false)
}

function updateY2() 
{
  update('y',2,false);
}

function updateY3() 
{
  update('y',3,false);
}